import { useState } from "react";
import { Navigate } from "react-router-dom";
import { LogIn } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setError("");
    const res = await login(email, password);
    setLoading(false);
    if (!res.ok) setError(res.error);
  };

  return (
    <div className="min-h-screen bg-carbon-grid flex items-center justify-center p-4" data-testid="admin-login-page">
      <div className="w-full max-w-md bg-hp-dark border border-white/10 p-8">
        <div className="flex items-center gap-3 mb-8">
          <img src="/assets/logo-horsepower.png" alt="Horsepower Garage" className="h-10 w-auto" />
          <span className="font-display font-black text-sm uppercase tracking-tight text-hp-yellow">Admin</span>
        </div>
        <h1 className="font-display font-bold uppercase tracking-tight text-2xl mb-6">Connexion</h1>
        <form onSubmit={submit} className="space-y-4" data-testid="admin-login-form">
          <div>
            <label className="block text-xs font-bold tracking-widest uppercase text-neutral-400 mb-2">Email</label>
            <input type="email" className="w-full bg-hp-dark border border-white/10 px-4 py-3 text-white focus:outline-none focus:border-hp-yellow" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="admin-email" />
          </div>
          <div>
            <label className="block text-xs font-bold tracking-widest uppercase text-neutral-400 mb-2">Mot de passe</label>
            <input type="password" className="w-full bg-hp-dark border border-white/10 px-4 py-3 text-white focus:outline-none focus:border-hp-yellow" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-password" />
          </div>
          {error && <p className="text-red-400 text-sm" data-testid="admin-login-error">{error}</p>}
          <button type="submit" disabled={loading} className="hp-cta w-full px-6 py-4 flex items-center justify-center gap-2 disabled:opacity-60" data-testid="admin-login-submit">
            <LogIn size={18} /> {loading ? "Connexion..." : "Se connecter"}
          </button>
        </form>
      </div>
    </div>
  );
}
